export default {
  // htmlFontSize: 16,
  // fontWeightLight: 300,
  // fontWeightRegular: 400,
  // fontWeightMedium: 500,
  // fontWeightBold: 600,
  h1: {
    fontWeight: 800,
    fontSize: '2.6rem',
    letterSpacing: '-0.24px',
  },
  h2: {
    fontWeight: 600,
    fontSize: '2.071rem',
    letterSpacing: '-0.24px',
  },
  h3: {
    fontWeight: 600,
    fontSize: '1.714rem',
    letterSpacing: '-0.06px',
  },
  h4: {
    fontWeight: 500,
    fontSize: '1.429rem',
    letterSpacing: '-0.06px',
  },
  h5: {
    fontWeight: 500,
    fontSize: '1.143rem',
    letterSpacing: '-0.05px',
  },
  h6: {
    fontWeight: 500,
    fontSize: '1rem',
    letterSpacing: '-0.05px',
  },
  overline: {
    fontWeight: 500,
    lineHeight: 1.66,
  },
  caption: {
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 1.66,
  },
  // body1: {
  //   fontSize: '0.875rem',
  //   lineHeight: 1.57,
  // },
  // body2: {
  //   fontSize: '0.75rem',
  //   lineHeight: 1.66,
  // },
  // subtitle1: {
  //   fontSize: '0.875rem',
  //   fontWeight: 600,
  //   lineHeight: 1.57,
  // },
  // subtitle2: {
  //   fontSize: '0.75rem',
  //   fontWeight: 500,
  //   lineHeight: 1.66,
  // },
  button: {
    textTransform: 'capitalize',
  },
};
